import '../../styles/components/_object-lock.scss';
import { updateCart } from '../services/cart.service';
export default (() => {
    console.log('UNTUCKit : Module : ObjectLock : loaded');
    const passwordError = () => document.querySelector('.password-error span');
    const resetCartPassword = async () => {
        console.log('UNTUCKit : Module : ObjectLock : resetCartLock : success');
        try {
            await updateCart({ attributes: { unlock: '' } });
            console.log('UNTUCKit : Module : ObjectLock : resetCartLock : success');
        }
        catch {
            // Leave the lock page in place when the cart update fails.
        }
    };
    const onSubmit = async (event) => {
        console.log('UNTUCKit : Module : ObjectLock : collection-unlock-form : submit');
        event.preventDefault();
        const error = passwordError();
        if (error) {
            error.style.visibility = 'hidden';
        }
        const password = document.querySelector('#unlock_id_password')?.value ?? '';
        if (password.length === 0) {
            if (error) {
                error.style.visibility = 'visible';
                error.innerHTML = 'Password Required';
            }
            return;
        }
        try {
            await updateCart({ attributes: { unlock: password } });
            window.location.reload();
        }
        catch {
            // Leave the lock page in place when the cart update fails.
        }
    };
    const bindUIActions = () => {
        console.log('UNTUCKit : Module : ObjectLock : bindUIActions');
        document.getElementById('object-unlock-form')?.addEventListener('submit', onSubmit);
    };
    const init = () => {
        console.log('UNTUCKit : Module : ObjectLock : init');
        window.addEventListener('load', () => {
            bindUIActions();
        });
        if (document.querySelector('.password-error-active')) {
            resetCartPassword();
        }
    };
    return { init };
})();
